//Created by wangshuyi on 2019-04-04.

'use strict';

/**
 * xml字符串转json
 * @param xmlStr
 * @return json
 */
function xml2json(xmlStr){
  let xmlDoc = xmlStr2Doc(xmlStr);
  return xmlDoc2Json(xmlDoc);
}

/**
 * 通过传入xml的内容字符串来解析xml
 * @param xmlStr xml字符串
 * @returns xml的Document对象
 */
function xmlStr2Doc(xmlStr) {
  let xmlDoc = null;
  if (window.DOMParser) {
    let parser = new DOMParser();
    xmlDoc = parser.parseFromString(xmlStr, "text/xml");
  } else {
    //IE
    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
    xmlDoc.async = "false";
    xmlDoc.loadXML(xmlStr);
  }
  return xmlDoc;
}

/**
 * 将XML的Document对象转换为JSON字符串
 * @param xmlDoc xml的Document对象
 * @return json
 */
function xmlDoc2Json(xmlDoc) {
  //准备JSON字符串和缓存（提升性能）
  let json = {};

  //获取xml文档的所有子节点
  let nodeList = xmlDoc.childNodes;
  generate(nodeList, json);

  /**
   * 中间函数，用于递归解析xml文档对象，并附加到json字符串中
   * @param node_list xml文档的的nodeList
   * @param parent 上级节点
   */
  function generate(node_list, parent) {
    for (let i = 0; i < node_list.length; i++) {
      let curr_node = node_list[i];
      //忽略子节点中的换行和空格
      if (curr_node.nodeType === 3) {
        continue;
      }
      //如果子节点还包括子节点，则继续进行遍历
      let curJson;
      if (curr_node.childNodes.length > 1) {
        curJson = [];
        generate(curr_node.childNodes, curJson);

        if(parent instanceof Array){
          parent.push(curJson);
        }else{
          parent[curr_node.nodeName] = curJson;
        }
      } else {
        let firstChild = curr_node.childNodes[0];
        let value = firstChild && firstChild.nodeValue;
        if(parent instanceof Array){
          parent.push(value);
        }else{
          parent[curr_node.nodeName] = value;
        }
      }
    }
  }

  return json;
}

module.exports = xml2json;
